<div class="container">
  <mat-card>
    <form [formGroup]="paymentTypeForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Payment Type' | translate }}</mat-label>
            <input required matInput formControlName="name" />
            @if (paymentTypeForm.controls.name.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Payment Type' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Description' | translate }}</mat-label>
            <textarea matInput formControlName="description" cdkTextareaAutosize cdkAutosizeMinRows="2"></textarea>
          </mat-form-field>

          <mat-checkbox labelPosition="before" formControlName="isCashPayment" class="status">
            {{ 'labels.inputs.Is Cash Payment' | translate }}?
          </mat-checkbox>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Position' | translate }}</mat-label>
            <input required matInput type="number" min="1" formControlName="position" />
            @if (paymentTypeForm.controls.position.hasError('min')) {
              <mat-error> {{ 'labels.inputs.Position' | translate }} must be a positive number. </mat-error>
            }
            @if (paymentTypeForm.controls.position.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Position' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!paymentTypeForm.valid"
          *LOSxHasPermission="'UPDATE_PAYMENTTYPE'"
        >
          {{ 'labels.buttons.Submit' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
